import { ApiFunusSale } from './types';
import axios from 'config/axios';

export const sale: ApiFunusSale = {
  getSaleById: (id) => axios.get(`/sale/${id}`),
  getSales: (params) => axios.post('/sales', params),
  saveSale: (params) => axios.post('/sale', params),
};
